<template>
<b-modal id="forgot-username-modal" title="Recover your username" @show="resetModal" @shown="afterShow" ok-title="Recover my username" @ok="recoverUsername">
  <b-form inline>
    <label class="w-25" for="email-input">Email:</label>
    <b-form-input v-model="email" id="email-input" ref="emailInput" class="w-75" aria-describedby="email-input-feedback" :state="emailState" v-on:input="resetError" @keydown.native.enter="recoverUsername">
    </b-form-input>
    <b-form-invalid-feedback id="email-input-feedback" class="text-right">{{recoverUsernameError}}</b-form-invalid-feedback>
  </b-form>
  <b-alert v-model="showEmailAlert" variant="success" dismissible class="mt-3">
    Username has been sent to your email address.
  </b-alert>
</b-modal>
</template>

<script>
import client from 'api-client';

export default {
  name: 'ForgotPasswordModal',
  data: function() {
    return {
      email: null,
      recoverUsernameError: null,
      showEmailAlert: false
    };
  },
  computed: {
    emailState() {
      if (this.recoverUsernameError) {
        return false;
      }
      return null;
    }
  },
  methods: {
    resetModal: function() {
      this.email = null;
      this.resetError();
    },
    resetError: function() {
      this.recoverUsernameError = null;
    },
    afterShow: function() {
      this.$refs.emailInput.focus();
    },
    recoverUsername(event) {
      // Prevent modal from closing
      event.preventDefault();

      this.showEmailAlert = false;
      if (!this.email) {
        this.recoverUsernameError = "Email is required";
      } else {
        client.recoverUsername(this.email)
          .then(() => {
            this.showEmailAlert = true;
            this.email = null;
          })
          .catch(error => this.recoverUsernameError = error.message);
      }
    }
  }
}
</script>
